import { useMutation, useQueryClient } from "@tanstack/react-query";
import { myInvitationsKeys } from "Auth/Api/Queries/Invitations/useGetMyInvitationsQuery";
import { postInvitationsPublicIDDecline } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

/**
 * Declines a pending RoleInvitation (Status → Declined). The linked Pending IdentityUser is
 * deactivated server-side so the inviter can simply re-send access; the inviter can also withdraw
 * a still-pending invitation via the merchant cancel-access endpoint.
 */
export const useDeclineInvitationMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((publicID: string) =>
      postInvitationsPublicIDDecline(publicID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: myInvitationsKeys.all });
      onSuccess?.();
    },
    onError,
  });
};
